import { PaymentStatus } from "../../../../core/schema/PaymentStatus.js";
import { DotType } from "../../Dot.js";

export const paymentStatusDotTypeMap: Record<PaymentStatus, DotType> = {
	[PaymentStatus.Unpaid]: DotType.Error,
	[PaymentStatus.PaidPartially]: DotType.Info,
	[PaymentStatus.Paid]: DotType.Success,
	[PaymentStatus.Refunded]: DotType.Info,
	[PaymentStatus.AwaitingRefund]: DotType.Info,
};
